import { useEffect, useState } from 'react';

import { theme } from '@olist/united';

const useResponsiveFirstSteps = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileStepActive, setIsMobileStepActive] = useState(false);
  const [shouldHiddenOnMobile, setShouldHiddenOnMobile] = useState(false);

  const getBreakpointInPx = (index) => theme.breakpoints[index].replace('em', '') * 16;

  useEffect(() => {
    const handleMobile = () => {
      const mobileFirstSizePx = getBreakpointInPx(0);
      setShouldHiddenOnMobile(window.innerWidth <= mobileFirstSizePx);

      const mobileSecondSizePx = getBreakpointInPx(3);
      const isMobileSize = window.innerWidth <= mobileSecondSizePx;
      setIsMobile(isMobileSize);

      if (!isMobileSize) {
        setIsMobileStepActive(false);
      }
    };

    handleMobile();

    window.addEventListener('resize', handleMobile);

    return () => window.removeEventListener('resize', handleMobile);
  }, []);

  return {
    isMobile,
    isMobileStepActive,
    shouldHiddenOnMobile,
    setIsMobileStepActive,
  };
};

export default useResponsiveFirstSteps;
